import * as React from "react";
import { ContextStore } from "../../../../../../../react-core/Flux/Variables";
import { ContextType } from "../../../../../../../Wrap/Constants/Enums/ContextType";
import { AssetClassType } from "../../../../../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { InvestmentAssetClassAllocationModel } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/InvestmentAssetClassAllocationModel";
import { InvestmentGeographicAllocationModel } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/InvestmentGeographicAllocationModel";
import { InvestmentSectorAllocationModel } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/InvestmentSectorAllocationModel";
import { TopTenHoldingModel } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/PortfolioDetails/TopTenHoldingModel";
import { User } from "../../../../../../../Wrap/Models/Models/User/User";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { LoadingSkeletonType } from "../../../../../../Shared/LoadingSkeleton/Contents";
import { LoadingSkeletonWrapper } from "../../../../../../Shared/LoadingSkeleton/LoadingSkeletonWrapper";
import { AsAtDatePicker } from "../../../../../Common/AsAtDatePicker";
import { UserStore } from "../../../../../Stroes/Variable";
import { InsightsAction } from "./Action/InsightsAction";
import { AssetClassAllocationWidget } from "./Components/AssetClassAllocationWidget";
import { SectorAllocationWidget } from "./Components/SectorAllocationWidget";
import { TopTenChart } from "./Components/TopTenChart";
import { GeographicalAllocationMap } from "./Components/GeographicalAllocationMap";
import { Contents } from "./Resource/Contents";
import { IPortfolioDashboardComponentProps, PortfolioDashboardComponent } from "../Common/PortfolioDashboardComponent";
import { PresentationViewButton } from "../Common/PresentationViewButton";
import { PresentationContext } from "../Common/PresentationViewWrapper";
import { Navigator } from "../../../../../../Shared/Wizards/Entities/Navigator";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { ClientAccount } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import {
    ConsolidatedAccountStore,
    PortfolioDashboardMultiSelectionStore,
    PortfolioDashboardStore,
} from "../../Store/Variable";
import { isConsolidate, selectedHeadAccounts } from "../Common/PortfolioDashboardHelper";
import { Urls } from "../../../../../Urls";
import { checkPermission } from "../../../../../../Shared/Permission/PermissionHelper";
import { UserClaim } from "../../../../../../../Wrap/Constants/Enums/UserClaim";
import AdviserSiteTagManager, {
    eventCategoryForGTM,
} from "../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { HierarchyLevelName } from "../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { portfolioDashboardTabEnum } from "../../Resource/Content";
import { Lightbox } from "../../../../../../../react-core/Html/Components/Lightbox";

interface IPortfolioDashboardInsightsState {
    userInfo: User;
    startDate?: Date;
    accountViewSelected: string[];
    geographicAllocationData: Array<InvestmentGeographicAllocationModel>;
    isLoading: boolean;
    assetSectorAllocationData: InvestmentSectorAllocationModel;
    isLoadingAssetSectorAllocationData: boolean;
    assetAllocationData: InvestmentAssetClassAllocationModel;
    isLoadingAssetSectorAllocation: boolean;
    tier: AssetClassType;
    topTenData: Array<TopTenHoldingModel>;
    isLoadingTopTen: boolean;
    slideNumber: number;
    showReportPop: boolean;
    reportLinkAccount: ClientAccount;
    accountsForReport: ClientAccount[];
}

interface IPortfolioDashboardInsightsProps extends IPortfolioDashboardComponentProps {}

export class PortfolioDashboardInsights extends PortfolioDashboardComponent<
    IPortfolioDashboardInsightsProps,
    IPortfolioDashboardInsightsState
> {
    constructor(props: IPortfolioDashboardInsightsProps) {
        super(props);
    }

    initState() {
        this.state = {
            userInfo: UserStore.getUserInfo(),
            tier: AssetClassType.Tier1,
            startDate: new Date(),
            accountViewSelected: [],
            geographicAllocationData: null,
            isLoading: true,
            assetSectorAllocationData: null,
            isLoadingAssetSectorAllocationData: true,
            assetAllocationData: null,
            isLoadingAssetSectorAllocation: true,
            topTenData: null,
            isLoadingTopTen: true,
            slideNumber: 0,
            showReportPop: false,
            reportLinkAccount: null,
            accountsForReport: [],
        };
    }

    componentDidMount() {
        super.componentDidMount();
        const indexIsBtnPresentationClicked = Object.keys(portfolioDashboardTabEnum).indexOf(
            portfolioDashboardTabEnum.Insights
        );
        if (this.props.isBtnPresentationClicked[indexIsBtnPresentationClicked]) {
            this.props.onPresentationViewStatusChange(
                portfolioDashboardTabEnum.Insights,
                this.props.isBtnPresentationClicked
            );
        } else {
            this.addEvent({
                environment: {
                    appType: "web",
                    setting: "prod",
                    timestamps: JsonDateParser.toJsonDateNoOffset(new Date()).toString(),
                },
                page: {
                    pageUrl: Urls.get()
                        .main.PortfolioDashboard({
                            hierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                HierarchyLevelName.Customer,
                                this.props.customerid
                            ),
                        })
                        .insights.getUrl(),
                    pageTitle: `${document.title} - client - insights`,
                },
                user: {
                    loginId: UserStore.getUserInfo()?.ClientId.toString(),
                    internal: "yes",
                },
                event: "pageLoaded",
            });
        }
    }

    getData(selectedSubAccountHierarchyIds: string[]) {
        this.setState(
            {
                geographicAllocationData: null,
                isLoading: true,
                accountViewSelected: selectedSubAccountHierarchyIds,
                assetSectorAllocationData: null,
                isLoadingAssetSectorAllocationData: true,
                assetAllocationData: null,
                isLoadingAssetSectorAllocation: true,
                topTenData: null,
                isLoadingTopTen: true,
            },
            () => {
                this.getGeographicData();
                this.getSectorAllocationData();
                this.getAssetAllocationData();
                this.getTopTenData();
            }
        );
    }

    private getTopTenData() {
        const { accountViewSelected, startDate } = this.state;
        InsightsAction.getTopTenData(startDate, accountViewSelected, true, false, (val) => {
            this.setState({
                topTenData: val,
                isLoadingAssetSectorAllocation: false,
            });
        });
    }

    private getAssetAllocationData() {
        const { accountViewSelected, startDate, tier } = this.state;
        let combinedAccounts = accountViewSelected;
        if(isConsolidate()){
            combinedAccounts = accountViewSelected.concat(ConsolidatedAccountStore.getData().HierarchyId);
        }
        InsightsAction.getInsightAssetAllocation(combinedAccounts, tier, startDate, (val) => {
            this.setState({
                assetAllocationData: val,
                isLoadingAssetSectorAllocation: false,
            });
        });
    }

    private getGeographicData() {
        const { accountViewSelected, startDate } = this.state;

        InsightsAction.getGeographicAllocation(accountViewSelected, startDate, (val) => {
            this.setState({
                geographicAllocationData: val,
                isLoading: false,
            });
        });
    }

    private renderGeographicView(): JSX.Element {
        const { geographicAllocationData, accountViewSelected, startDate } = this.state;
        return (
            <LoadingSkeletonWrapper isLoading={!geographicAllocationData} skeletonType={LoadingSkeletonType.Chart}>
                <GeographicalAllocationMap
                    mapData={geographicAllocationData}
                    accountSelectValue={accountViewSelected}
                    asAt={startDate}
                />
            </LoadingSkeletonWrapper>
        );
    }
    private renderTopTenView(): JSX.Element {
        const { topTenData } = this.state;
        if (topTenData && topTenData.length == 0) {
            return (
                <>
                    <div className="flex-space pb-8 pt-30">
                        <h2 className="h3 mb-0">Top 10</h2>
                    </div>
                    <Alert
                        alertType={AlertType.Warning}
                        message={"There are no current investment holdings on this portfolio."}
                    />
                </>
            );
        } else {
            return (
                <LoadingSkeletonWrapper isLoading={!topTenData} skeletonType={LoadingSkeletonType.Chart}>
                    <TopTenChart data={topTenData} />
                </LoadingSkeletonWrapper>
            );
        }
    }

    private getSectorAllocationData() {
        const { accountViewSelected, startDate, tier } = this.state;
        InsightsAction.getInvestmentSectorAllocation(accountViewSelected, tier, startDate, (val) => {
            this.setState({
                assetSectorAllocationData: val,
                isLoadingAssetSectorAllocationData: false,
            });
        });
    }

    private renderSectorAllocationView(): JSX.Element {
        const { assetSectorAllocationData } = this.state;
        return (
            <LoadingSkeletonWrapper
                isLoading={!assetSectorAllocationData}
                skeletonType={LoadingSkeletonType.Chart}
                skeletonCssWrapper="mt-20"
            >
                <SectorAllocationWidget SectorAllocationData={assetSectorAllocationData} isHeadAccount={true} />
            </LoadingSkeletonWrapper>
        );
    }

    private renderAssetAllocationView(): JSX.Element {
        const { assetAllocationData, tier } = this.state;
        return (
            <LoadingSkeletonWrapper
                isLoading={!assetAllocationData}
                skeletonType={LoadingSkeletonType.PieChartAndTable}
                skeletonCssWrapper="mt-20"
            >
                <AssetClassAllocationWidget
                    data={assetAllocationData}
                    tier={tier}
                    isHeadAccount={true}
                    onApplyClick={(v) =>
                        this.setState(
                            { tier: v, assetAllocationData: null, isLoadingAssetSectorAllocation: true },
                            () => {
                                this.getAssetAllocationData();
                            }
                        )
                    }
                />
            </LoadingSkeletonWrapper>
        );
    }

    private noData(data: any[]) {
        return data && data.length < 1;
    }

    private handleLaunchpadClick() {
        const context: Record<string, string> = {};

        const customerHierarchyId = ContextStore.getUrlParamsHierarchyId(ContextType.Customer);
        if (customerHierarchyId) {context.customerId = customerHierarchyId;}

        (window as any).AppStore.open(context);
    }

    private addEvent = new AdviserSiteTagManager().addEvent;

    render() {
        const {
            geographicAllocationData,
            assetSectorAllocationData,
            assetAllocationData,
            startDate,
            accountViewSelected,
            slideNumber,
        } = this.state;

        const { isPresentationView } = this.context;

        const nodata =
            this.noData(geographicAllocationData) ||
            (assetAllocationData && this.noData(assetAllocationData.InvestmentAssetClassAllocations)) ||
            (assetSectorAllocationData && this.noData(assetSectorAllocationData.InvestmentSectorAllocations));

        const isAppStoreEnabled = this.state.userInfo?.IsAppStoreEnabledForUser;

        return (
            <div role={isPresentationView ? "main" : "tabpanel"} id="panel-3" tabIndex={0} aria-labelledby="tab-3">
                <div className="ad d1">
                    <div className="row pt-20 pb-20">
                        <div className="col-8">
                            <AsAtDatePicker
                                selected={startDate}
                                accountViewSelected={null}
                                onChange={(d) => {
                                    this.addEvent({
                                        event: "insightstab_interaction",
                                        eventParameters: {
                                            eventCategory: eventCategoryForGTM.insightsTab,
                                            eventAction: "interactions",
                                            eventLabel: "date widget",
                                        },
                                    });
                                    this.setState({ startDate: d }, () => this.getData(accountViewSelected));
                                }}
                                cssWrapper="label-sr-only w-250"
                            />
                        </div>
                        <div className="col-4 col-right">
                            <div className="row row-right">
                                <div className="col-auto">
                                    <PresentationViewButton
                                        onClick={() => {
                                            this.addEvent({
                                                event: "insightstab_interaction",
                                                eventParameters: {
                                                    eventCategory: eventCategoryForGTM.insightsTab,
                                                    eventAction: "interactions",
                                                    eventLabel: "presentation mode",
                                                },
                                            });
                                            this.props.onPresentationViewStatusChange(
                                                portfolioDashboardTabEnum.Insights,
                                                this.props.isBtnPresentationClicked
                                            );
                                        }}
                                    />
                                </div>
                                {isAppStoreEnabled && (
                                    <div className="col-auto">
                                        <button
                                            type="button"
                                            className="applications-pad-button"
                                            onClick={this.handleLaunchpadClick.bind(this)}
                                        >
                                            <span className="sr-only">Applications pad</span>
                                            <span className="icon" aria-hidden="true"></span>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {nodata ? (
                        <Alert alertType={AlertType.Warning} message={Contents.noDataErrorMessage} />
                    ) : (
                        <>
                            <div className="panel-subtle">
                                <div className="row narrow-gutter pb-8">
                                    <div className="col-fluid">
                                        <h2>{Contents.GeographicTitle}</h2>
                                    </div>
                                    {checkPermission(UserClaim.AdviserPortalClientPortfolioReportReadWrite) && (
                                        <div className="col-auto">
                                            <button
                                                type="button"
                                                className="document-button"
                                                onClick={() => {
                                                    this.addEvent({
                                                        event: "insightstab_interaction",
                                                        eventParameters: {
                                                            eventCategory: eventCategoryForGTM.insightsTab,
                                                            eventAction: "interactions",
                                                            eventLabel: "create report",
                                                        },
                                                    });
                                                    let headAccounts = selectedHeadAccounts(
                                                        PortfolioDashboardMultiSelectionStore.getData(),
                                                        PortfolioDashboardStore.getData()
                                                    );
                                                    if (isConsolidate()) {
                                                        headAccounts = [ConsolidatedAccountStore.getData()].concat(
                                                            headAccounts
                                                        );
                                                    }
                                                    if (headAccounts.length == 1) {
                                                        Navigator.navigateTo(
                                                            Urls.get()
                                                                .main.PortfolioDashboard({
                                                                    hierarchyId: ContextStore.getUrlParamsHierarchyId(
                                                                        ContextType.Customer
                                                                    ),
                                                                })
                                                                .clientReport({
                                                                    headaccounthierarchyId:
                                                                        headAccounts[0]?.HierarchyId,
                                                                }).clientReport
                                                        );
                                                    } else {
                                                        this.setState({
                                                            showReportPop: true,
                                                            accountsForReport: headAccounts,
                                                        });
                                                    }
                                                }}
                                            >
                                                <span className="icon" aria-hidden="true"></span>Create client portfolio
                                                report
                                            </button>
                                        </div>
                                    )}
                                </div>
                                {this.renderGeographicView()}
                            </div>
                            {/* {this.renderTopTenView()} */}
                            {this.renderAssetAllocationView()}
                            {this.renderSectorAllocationView()}
                            {this.state.showReportPop && (
                                <Lightbox
                                    title="Select an account to create report "
                                    show={this.state.showReportPop}
                                    cssWrapper="is-default-lightbox"
                                    onClose={() => this.setState({ showReportPop: false, reportLinkAccount: null })}
                                >
                                    <SelectEditor
                                        onChange={(v) => this.setState({ reportLinkAccount: v })}
                                        options={this.state.accountsForReport}
                                        placeholder="Please select"
                                        selected={this.state.reportLinkAccount}
                                        cssWrapper={"control-size-245"}
                                        getText={(o) => o?.HeadClAccountId}
                                    />
                                    {checkPermission(UserClaim.AdviserPortalClientPortfolioReportReadWrite) && (
                                        <button
                                            className="btn primary"
                                            disabled={this.state.reportLinkAccount == null}
                                            onClick={() =>
                                                Navigator.navigateTo(
                                                    Urls.get()
                                                        .main.PortfolioDashboard({
                                                            hierarchyId: ContextStore.getUrlParamsHierarchyId(
                                                                ContextType.Customer
                                                            ),
                                                        })
                                                        .clientReport({
                                                            headaccounthierarchyId: this.state.reportLinkAccount
                                                                .HierarchyId,
                                                        }).clientReport
                                                )
                                            }
                                        >
                                            Create Client Portfolio Report
                                        </button>
                                    )}
                                </Lightbox>
                            )}
                        </>
                    )}
                </div>
            </div>
        );
    }
}
PortfolioDashboardInsights.contextType = PresentationContext;
